import { OtherDocumentRepository} from "../domain/OtherDocumentRepository";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";


export class ApiOtherDocumentRepository implements OtherDocumentRepository{
    
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    constructor() {
        this.query_dispatcher = query_dispatcher_get
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
    }

    async get_documents(args: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('filtered.documents', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async get_document_url(id){
        let res = await this.query_dispatcher.dispatch('get.other.doc.url', { doc_id: id })
        return res.url
    }

    async get_cropped_document_url(id: any): Promise<string> {
        try {
            let res = await this.query_dispatcher.dispatch('get.cropped.doc.url', { doc_id: id })
            return res.url
        } catch (error) {
            console.error(error)
            return ''
        }
    }

    async get_original_document_url(id: any): Promise<string> {
        try {
            let res = await this.query_dispatcher.dispatch('get.original.doc.url', { doc_id: id })
            return res.url
        } catch (error) {
            console.error(error)
            return ''
        }
    }

    async find_by_id(id: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.document', { id: id })
            console.log(res)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async aproveDocument(id: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('approve.document', { doc_id: id })
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async rejectDocument(id: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('reject.document', { doc_id: id })
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async saveDocumentComments(args: any): Promise<any> {
        try {
           await this.sync_command_dispatcher.dispatch('save.document.comments', args);
        } catch (error) {
            console.error(error)
        }
    }

    async getAvailableTypes(): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.document.types', {})
            return res
        } catch (error) {
            console.error(error)
            return []
        }
    }

    async saveDocumentTypes(types: Array<string>): Promise<any> {
        let args = { types: types }
        try {
            await this.sync_command_dispatcher.dispatch('save.document.types', args);
        } catch (error) {
            console.error(error)
        }
    }
    
    async deleteDocuments(args: any): Promise<void> {
        // let args = { document_ids: document_ids }
        try {
            await this.sync_command_dispatcher.dispatch('delete.documents', args);
        } catch (error) {
            console.error(error)
        }
    }

    async moveDocsToFolder(args: any): Promise<void> {
        try {
            await this.sync_command_dispatcher.dispatch('move.document.to.a.folder', args);
        } catch (error) {
            console.error(error)
        }
    }

    async downloadDocuments(args: any): Promise<any> {
        // let args = { doc_ids: doc_ids }
        try {
            let res = await this.async_command_dispatcher.dispatch('download.document', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async changeDocsWorkflow(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('modify.document.workflow', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async saveFolder(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('save.folder', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async callContinueWorkflow(args: any): Promise<any> {
        try {
            let res = await this.sync_command_dispatcher.dispatch('continue.workflow', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }

    async getCompanyFolders(args: any): Promise<any> {
        try {
            let res = await this.query_dispatcher.dispatch('get.company.folders', args)
            return res
        } catch (error) {
            console.error(error)
            return null
        }
    }
}

export class MemoryOtherDocumentRepository implements OtherDocumentRepository {
        documents: Array<any> = []

        constructor(data) {
            this.documents = data
        }

        async get_documents(args: any): Promise<any> {
            let company_id = args['company_id']
            let res = await this.documents.filter(doc => doc.company_id == company_id)
            return {data: res, count: res.length}
        }

        async get_document_url(id){
            let res = this.documents.find((doc: { id: any }) => doc.id == id)
            return res['path']
        }

        async get_cropped_document_url(id: any): Promise<string> {
            let res = this.documents.find(doc => doc.id == id)
            return res['cropped_path']
        }

        async get_original_document_url(id: any): Promise<string> {
            let res = this.documents.find(doc => doc.id == id)
            return res['original_path']
        }

        async find_by_id(id: any): Promise<any> {
            let res = this.documents.find(doc => doc.id == id)
            return res
        }

        async aproveDocument(id: any): Promise<any> {
            let res = this.documents.find(doc => doc.id == id)
            res['status'] = 'approved'
            return res
        }

        async rejectDocument(id: any): Promise<any> {
            let res = this.documents.find(doc => doc.id == id)
            res['status'] = 'rejected'
            return res
        }

        async saveDocumentComments(args: any): Promise<any> {
            this.documents.push(args)
        }

        async getAvailableTypes(): Promise<any> {
            let res = ['contract', 'bill']
            return res
        }

        async saveDocumentTypes(types: Array<string>): Promise<any> {
            return
        }

        async deleteDocuments(args: any): Promise<void> {
            this.documents = this.documents.filter(doc => !args.document_ids.includes(doc.id))
        }

        async downloadDocuments(args: any): Promise<any> {
            return
        }

        async changeDocsWorkflow(args: any): Promise<any> {
            let res = this.documents.find(doc => doc.id == args.doc_id)
            res['workflow'] = args.workflow
            return res
        }

        async callContinueWorkflow(args: any): Promise<any> {
            return
        }

        async getCompanyFolders(args: any): Promise<any> {
            return {}
        }

        async moveDocsToFolder(args: any): Promise<void> {
            return
        }

        async saveFolder(args: any): Promise<any> {
            return
        }
        
 
}